import { useActiveDivision } from "@citychallenge/core";

import { WEB_CONFIG } from "../../core/web-config";

/**
 * Name and logo of the division serving the pages. Falls back to the
 * server-injected config, which is all that exists on a cold load.
 */
export function useDivisionInfo(): { name?: string; icon?: string } {
  const division = useActiveDivision();
  return {
    name: division?.name ?? WEB_CONFIG.DIVISION_INFO?.name,
    icon: division?.icon ?? WEB_CONFIG.DIVISION_INFO?.icon,
  };
}
